import { UnlockAccount1AlertProps, UnlockAccount1Fields } from "../../components/SmartErrorAlert";
import translate from "../translate";
import { createAccount1ApiErrorContent, createAccount1InvalidFieldMessages, createAccountStep1ErrorFns } from "./createAccount1Errors";
import { ErrorContentGenerator, ErrorContentMap, InvalidFieldMessages } from "./getAlertContent";

export type UnlockAccount1ErrState = 'notFound' | 'invalidBedapInfo' | 'unknown';
export const apiErrorContent: ErrorContentMap<UnlockAccount1ErrState> = {
    // TODO should this match "notFound" for create account?
    notFound: {
        header: translate("we_cant_find_you"),
        body: <>
            {translate("check_mbi_start_date_try_again")}<br />
            {translate("for_more_help_call")} (<a href="tel:18006334227">1-800-633-4227</a>).{" "}
            {translate("tty_users_can_call")}{" "}<a href="tel:18774862048">1-877-486-2048</a>.
        </>,
        analyticsErr: "We can't find you in our records. Check your Medicare Number and coverage start date and try again.For more help, call 1-800-MEDICARE (1-800-633-4227). TTY users can call 1-877-486-2048."
    },
    invalidBedapInfo: createAccount1ApiErrorContent.invalidBedapInfo,
    unknown: {
        header: createAccount1ApiErrorContent.unknown.header,
        body: translate("we_are_sorry_for_inconvenience_try_unlocking_account_later"),
        analyticsErr: "We can't process your request at this time. We're sorry for any inconvenience. Try unlocking your account later."
    }
};

const invalidFieldMessages: InvalidFieldMessages<UnlockAccount1Fields> = createAccount1InvalidFieldMessages;

export const unlockAccountStep1ErrorFns = new ErrorContentGenerator<UnlockAccount1AlertProps, UnlockAccount1Fields, UnlockAccount1ErrState>({
    apiErrorContent,
    invalidFieldMessages,
    invalidFieldHeader: 'complete_items_to_unlock_account',
    getRefMap: props => {
        return {
            mbi: props.mbiRef,
            coverageStartDate: props.coverageStartDateRef
        }
    },
    getErrState: apiResponse => {
        if (!apiResponse) {
            return null;
        }

        const { errors } = apiResponse.data;
        switch (apiResponse.status) {
            case 400:
                const notFound = errors?.some(x => x.message.includes('did not match'));
                if (notFound) {
                    return 'notFound';
                }
                const invalidFields = unlockAccountStep1ErrorFns.getApiInvalidFields(apiResponse);
                if (invalidFields.length) {
                    return null;
                }
                return 'unknown';
            case 401:
                return 'invalidBedapInfo'
            case 404:
                const notLocked = errors?.some((error: any) =>
                    error.message.includes("user is not locked")
                );
                if (notLocked) {
                    return null;
                }
                return 'notFound';
            default:
                return 'unknown';
        }
    },
    getApiInvalidFields: createAccountStep1ErrorFns.getApiInvalidFields,
    isIntermediateStep: true
});